
// export const URL_DATA_REALESTATE_TEST_DEV = "http://dios.local.cloudnine.se/api/fastighet";
export const URL_DATA_REALESTATE_TEST_DEV = "/data/fastighet.json";
export const URL_DATA_PREMISES_TEST_DEV = "/data/lokal.json";
// export const URL_DATA_PREMISES_TEST_DEV = "http://dios.local.cloudnine.se/api/lokal";
export const URL_DATA_RESIDENCE_TEST_DEV = "/data/bostad.json";

// export const URL_DATA_REALESTATE_TEST_BUILD = "/UI/build/fastigheter.json";
export const URL_DATA_REALESTATE_BUILD = "/api/fastighet";
export const URL_DATA_PREMISES_BUILD = "/api/lokal";
export const URL_DATA_RESIDENCE_BUILD = "/api/bostad";

export const URL_DATA_FILTERS_AREA_DEV = "/data/filterArea.json";
export const URL_DATA_FILTERS_RENT_DEV = "/data/filterRent.json";
export const URL_DATA_FILTERS_SEARCH_DEV = "/data/filterSearchCriteria.json";

export const URL_DATA_FILTERS_AREA = "/UI/build/data/filterArea.json";
export const URL_DATA_FILTERS_RENT = "/UI/build/data/filterRent.json";
export const URL_DATA_FILTERS_SEARCH = "/UI/build/data/filterSearchCriteria.json";

export const URL_GLOBAL_SEARCH = "/api/search";
export const URL_GLOBAL_SEARCH_DEV = "http://dios.local.cloudnine.se/api/search";
// export const URL_GLOBAL_SEARCH_DEV = "/data/search_sundsvall.json";
export const URL_GLOBAL_SEARCH_DEV_2 = "/data/search_umea.json";
export const HOURS_BEFORE_EXPIRE = 1;

export const URL_CITY_RELATIONSHIP = "/api/cities";
export const URL_CITY_RELATIONSHIP_DEV = "http://dios.local.cloudnine.se/api/cities";

export const SEL_SEARCH_TOGGLE = "[data-js='quicksearch-toggle']";

export const STR_ALL = "Alla";
export const STR_ALL_CITIES = "Alla städer";
export const STR_ALL_OBJECTTYPES = "Alla typer";
export const STR_ALL_AREA = "Alla storlekar";
export const URI_ALL_CITIES = "alla_städer";
export const URI_ALL_OBJECTTYPES = "alla";
export const URI_ALL_AREA = "alla";

export const REALESTATE_PATH_PARAM = "/vara-fastigheter/";
export const PREMISIS_PATH_PARAM = "/lokaler/";

export const URI_SEARCH = "/sok/";
export const SEARCH_PLACEHOLDER = "Sök hela webbplatsen";
export const MAX_SEARCH_RESULTS = 5;
// export const PATH_PARAM_SEARCH_ALL = "allt";
// export const PATH_PARAM_SEARCH_OBJECTS = "objekt";
// export const PATH_PARAM_SEARCH_ARTICLES = "artiklar";
// export const PATH_PARAM_SEARCH_PRESSRELEASE = "pressrelease";
//
// export const SEARCH_ALL = "all";
// export const SEARCH_OBJECTS = "objects";
// export const SEARCH_ARTICLES = "articles";
// export const SEARCH_PRESSRELEASE = "pressrelease";

export const REALESTATE = "realestate";
export const PREMISES = "premises";
export const RESIDENCE = "residence";

export const REALESTATE_SV = "fastigheter";
export const PREMISES_SV = "lokaler";
export const RESIDENCE_SV = "bostäder";

export const REALESTATE_PLUR_SV = "fastigheter";
export const PREMISES_PLUR_SV = "lokaler";
export const RESIDENCE_PLUR_SV = "bostäder";

export const REALESTATE_SING_SV = "fastighet";
export const PREMISES_SING_SV = "lokal";
export const RESIDENCE_SING_SV = "bostad";
//
export const category_words = {
	"realestate" : {
		"singluar": "fastighet",
		"plural": "fastigheter"
	},
	"premises" : {
		"singluar": "lokal",
		"plural": "lokaler"
	},
	"residence" : {
		"singluar": "bostad",
		"plural": "bostäder"
	},
	"" : {
		"singluar": "",
		"plural": ""
	},
}

export const emptyObjectTitle = (categories)=>`Just nu finns det inga lediga ${categories}`;
export const emptyObjectText = (category)=>`Vi har inget kösystem - hos oss visar du intresse på en aktuell ${category}. Listan uppdateras kontinuerligt.`;



// WEBPACK FOOTER //
// ./src/js/constants/constants.js